import React, { useEffect, useState } from 'react';
import { saveContact, saveContactToGoogleSheet } from '../dataStore';
import './contact.css';

export default function Contact() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    info: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const recipientEmail = 'zeitamax.info@gmail.com';

  useEffect(() => {
    const openContactModal = () => {
      setSubmitted(false);
      setIsModalOpen(true);
    };
    window.addEventListener('zeitamax-open-contact', openContactModal);
    return () => window.removeEventListener('zeitamax-open-contact', openContactModal);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await saveContactToGoogleSheet(formData);
      saveContact(formData);
      const subject = `New contact request from ${formData.name}`;
      const body = [
        `Name: ${formData.name}`,
        `Phone: ${formData.phone}`,
        `Email: ${formData.email}`,
        `Message: ${formData.info}`
      ].join('\n');

      window.location.href = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      setSubmitting(false);
      setSubmitted(true);
      setFormData({ name: '', phone: '', email: '', info: '' });

      setTimeout(() => {
        setSubmitted(false);
        setIsModalOpen(false);
      }, 3000);
    } catch (error) {
      console.error('Error sending contact form:', error);
      setSubmitting(false);
      alert('Your details could not be saved. Please try again.');
    }
  };

  return (
    <>
      <section id="contact" className="zm-contact">
        <div className="zm-container zm-contact-inner">
          <div className="contact-copy">
            <p className="eyebrow">Let's build the future together</p>
            <h2>Partner with ZeitaMax</h2>
            <p>
              Whether you're looking to hire exceptional technology talent or searching for your next career opportunity, ZeitaMax is ready to help. Experience recruitment that delivers talent, trust, and transformation.
            </p>
            <div className="contact-details">
              <div>
                <strong>Email</strong>
                <a href="mailto:zeitamax.info@gmail.com">zeitamax.info@gmail.com</a>
              </div>
              <div>
                <strong>Phone</strong>
                <a href="tel:+919848754756">+91 9848754756</a>
              </div>
              <div>
                <strong>Address</strong>
                <span>GF-6, Block-4, Maheswari Towers, Nunna, Vijayawada.</span>
              </div>
            </div>
          </div>
          <div className="contact-card">
            <div className="card-inner">
              <h3>ZeitaMax</h3>
              <p>Connect with our talent experts and get access to top IT professionals backed by a transparent, high-touch hiring experience.</p>
              <button className="btn primary" onClick={() => setIsModalOpen(true)}>
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Modal Popup */}
      {isModalOpen && (
        <div className="zm-modal-overlay">
          <div className="zm-modal-content">
            <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            <h3>Get in Touch with ZeitaMax</h3>
            
            {submitted ? (
              <div className="success-message">
                <p>Thank you! Your details have been submitted successfully.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="zm-contact-form">
                <div className="form-group">
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    value={formData.phone} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Info / Message</label>
                  <textarea 
                    name="info" 
                    rows="4" 
                    value={formData.info} 
                    onChange={handleChange} 
                    required 
                  />
                </div>
                <button type="submit" className="btn primary submit-btn" disabled={submitting}>
                  {submitting ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
